'use client'
import React, { useContext, useEffect, useState } from 'react';
import { forwardRef } from '@chakra-ui/system';
import { Select } from 'chakra-react-select';
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Button,
} from '@chakra-ui/react';
import { Controller, useForm } from 'react-hook-form';
import { AuthContext } from '@/auth/lib/authContext';
import { ProductContext } from '../../lib/productContext';
import { ProductPageContext } from '../lib/productPageContext';
import useExperienceApi from '@/experiences/lib/useExperienceApi';
import useTranslation from '../../../lib/i18n/useTranslation';
const MoveExperienceInProductToGroupForm = forwardRef((props, ref) => {
  const { t } = useTranslation();
  const {
    productId,
    product,
    rights,
  } = useContext(ProductContext);
  const {
    experienceList,
    experienceGroupList,
    group,
  } = useContext(ProductPageContext);
  const {
    experienceId,
    hideSave,
    onSubmitted,
    onSubmitting,
    onValidityChange
  } = props;
  const {
    handleSubmit,
    errors,
    control,
    formState: { isSubmitting, isValid }
  } = useForm();
  const { profile } = useContext(AuthContext);
  const experienceApi = useExperienceApi();
  const [groupOptionsList, setGroupOptionsList] = useState(null);
  const [experience, setExperience] = useState(null);
  const onSubmit = async (data) => {
    try {
      if (onSubmitting) {
        onSubmitting();
      }
      const groupId = data.group.value
      if (groupId) {
        await experienceApi.moveExperienceToGroupInProduct(
          productId,
          experienceId,
          groupId
        );
      }
      if (onSubmitted) {
        onSubmitted();
      }
    } catch (e) {
      console.error(e);
    }
  };
  useEffect(() => {
    if (experienceGroupList && experienceId) {
      const experienceFiltered = experienceList.filter(e => e.id === experienceId)
      const newExperience = experienceFiltered[0]
      
      if (newExperience) {
        const groupOptionListInGroup = experienceGroupList
          .filter(eg => eg.group.id !== newExperience.product_experience_group_id && eg.group_id === group?.group.id)
          .map(eg => ({ label: eg.group.name, value: eg.group.id }))
        
        const otherGroupsOptionList = experienceGroupList
          .filter(eg => eg.group.id !== newExperience.product_experience_group_id && eg.group_id !== group?.group.id)
          .map(eg => ({ label: eg.group.name, value: eg.group.id }))
        
        setExperience(newExperience);
        setGroupOptionsList([{
          label: "In this group",
          options: groupOptionListInGroup,
        },{
          label: "Other",
          options: otherGroupsOptionList
        },{
          label: "Root",
          options: [{ label: "Root", value: null }]
        }]);
      } else {
        setExperience(null);
        
        const allGroups = experienceGroupList.map(eg => ({ 
          label: eg.group.name, 
          value: eg.group.id 
        }))
        
        const finalOptions = [{
          label: "Available Groups",
          options: allGroups,
        },{
          label: "Root",
          options: [{ label: "Root", value: null }]
        }]
        
        setGroupOptionsList(finalOptions);
      }
    }
  }, [experienceGroupList, experienceId, group]);
  useEffect(() => {
    if (onValidityChange) {
      onValidityChange(isValid);
    }
  }, [isValid]);
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} >
        <Controller
          control={control}
          name="group"
          rules={{ required: "Please select a group" }}
          render={({
            field: { onBlur, value, onChange },
          }) => (
            <FormControl isInvalid={errors && errors.group}>
              <FormLabel>Select a Group</FormLabel>
              <Select
                options={groupOptionsList}
                onBlur={onBlur}
                onChange={onChange}
                value={value}
                menuPortalTarget={document.body}
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
              />
              <FormErrorMessage>{errors && errors.group}</FormErrorMessage>
            </FormControl>
          )}
        />
        <Button
          style={{
            display: hideSave ? 'none' : 'inherit',
          }}
          ref={ref}
          isLoading={isSubmitting}
          disabled={!isValid}
          type='submit'
          my={2}
        >Save</Button>
      </form>
    </>
  );
});
export default MoveExperienceInProductToGroupForm;
